module.exports = __webpack_public_path__ + "img/solution32.9eeeb2f5.png";